<template>
  <app-layout>
    <div class="flex flex-col items-center justify-center text-center min-h-screen gap-10">
      <p class="py-4">
        <a href="javascript:;" onclick="window.history.back();" class="underline text-indigo-500">&larr; Go Back</a>
      </p>
      <h1 class="font-bold text-4xl">Server Error</h1>

      <!-- TODO: Custom error gif for clients to make relevant -->

      <img
        :src="image"
        alt="Error"
      >

      <pre v-if="error" class="max-width-full overflow-scroll">{{ error }}</pre>
    </div>
  </app-layout>
</template>
<script>
export default {
  name: 'Error',
  props: ['error'],
  data() {
    return {
      images: ['https://atypicdev.com/cms/soccerbot.webp', 'https://atypicdev.com/cms/error.webp']
    }
  },
  computed: {
    image() {
      return this.images[Math.floor(Math.random() * this.images.length)];
    }
  },
};
</script>
